import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { MatDialog } from '@angular/material/dialog';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { take } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { TypeMessage } from 'src/app/entity/enum/enum-notification';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-et004-card-III',
    templateUrl: './et004-card-III.component.html'
})

export class Et004CardIIIComponent extends GeneralComponent implements OnInit {

    public formulario?: FormGroup;
    public isReadOnlyPolimero?: boolean;
    public isReadOnlyAgua?: boolean;
    public isReadOnlyCaldaConvencional?: boolean;
    @Output() mkCalcIII = new EventEmitter();

    listOptionsPolimero: DropDownListDTO[];
    listOptionsPolimeroOriginal: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService, public dialog: MatDialog) {
        super('Dosagens', false);
        this.formulario = this.formBuilder.group({
            poncho: [null, []],
            cruiser: [null, []],
            redigo: [null, []],
            dermacor: [null, []],
            // derosal_plus: [null, []],
            polimero: [null, []],
            agua: [null, []],

            polimero_list: [null, []],
            calda_tsi: [null, []],



            calda_convencional: [null, []],
            id_calda_base: [null, []],
        });
        this.formulario.get('calda_convencional')['warning'] = false;
    }

    async ngOnInit(): Promise<void> {
        await this.getLists();
    }
    async getLists() {

        await this.listPolimero();
    }
    async listPolimero() {
        const site = localStorage.getItem('data_site');
        await this.formularioService
            .getListDropDownList('et004', 'polimero_list', site)
            .pipe(take(1))
            .toPromise()
            .then((response) => {
                if (!!response?.data) {
                    this.listOptionsPolimero = this.generalService.orderByDropDownList(
                        response.data as DropDownListDTO[]
                    );
                    this.listOptionsPolimeroOriginal = this.listOptionsPolimero;
                }
            })
            .catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(
                    error,
                    '',
                    TypeMessage.ListErrorPolimero
                );
            });
    }

    async createFilterPolimero(value?: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (
                this.listOptionsPolimeroOriginal.filter((x) =>
                    x.name?.toLowerCase().includes(value?.toLowerCase())
                ).length > 0
            ) {
                this.listOptionsPolimero = this.listOptionsPolimeroOriginal.filter((x) =>
                    x.name?.toLowerCase().includes(value?.toLowerCase())
                );
            } else {
                this.listOptionsPolimero = this.listOptionsPolimeroOriginal;
            }
        } else {
            this.listOptionsPolimero = this.listOptionsPolimeroOriginal;
        }
    }


    verifyFormValuesMaxMin(event: KeyboardEvent) {


        const min = 0;
        const max = 15;
        let changeValue = false;
        let value = this.formulario.get('calda_convencional').value as number
        console.log(value)
        if (isNaN(value)) {
            value = min;
        }

        if (value > max) {
            value = value / 10
            changeValue = true
        }
        if (changeValue) {

            this.formulario.get('calda_convencional').setValue((Number(Math.floor(value * 100) / 100).toFixed(2)))
        }
    }

    verifyCaldaConvencional() {
        const calda = this.formulario.get('calda_convencional')?.value
        if (calda < 8 || calda > 12)
            this.formulario.get('calda_convencional')['warning'] = true;
        else
            this.formulario.get('calda_convencional')['warning'] = false;
    }
    changePolimero() {
        this.mkCalcIII.emit()
    }

    changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }
}


